import { useState, type VoidFunctionComponent } from 'react';
import type { FormatName, FixPlanFormat } from './shared/types';
import type { FormatSelection, OnApply } from './shared/components/Filter';
import Filter from './shared/components/Filter';
import { ReportCategories } from '../ReportGeneration/utils';
import type { SetState } from '../../../../types';

type FixPlanFiltersProps = {
  onApply: OnApply;
  appliedFormat: FormatName | null;
  setIsDirty: SetState<boolean>;
  isApplyButtonDisabled: boolean;
};

const FixPlanFilters: VoidFunctionComponent<FixPlanFiltersProps> = ({
  isApplyButtonDisabled,
  onApply,
  appliedFormat,
  setIsDirty,
}: FixPlanFiltersProps) => {
  const pdfFormat: FixPlanFormat = { label: 'PDF', value: 'PDF' };
  const formats: FixPlanFormat[] = [
    pdfFormat,
    { label: 'HTML', value: 'HTML' },
    { label: 'JSON', value: 'JSON' },
  ];
  const [format, setFormat] = useState<FormatSelection>(pdfFormat);
  return (
    <Filter
      isApplyButtonDisabled={isApplyButtonDisabled}
      includeOptions={[]}
      dependencyMetadataOptions={[]}
      category={ReportCategories.FixPlan}
      appliedFormat={appliedFormat}
      format={format}
      setFormat={setFormat}
      setIsDirty={setIsDirty}
      formats={formats}
      onApply={onApply}
    />
  );
};

export default FixPlanFilters;
